export enum ADMIN_USERS {
  REQUESTOR = 'ADMIN_REQUESTOR',
  TRUCKING = 'ADMIN_TRUCKING'
}